import React, { lazy, useEffect, Suspense } from 'react';
import { Loader, TimeFormatsEnum } from '@wix/calendar-client-library-v3';

import {
  getStyleParams,
  isEditorViewMode,
  resizeComponent,
  setHeight,
} from '../../../../utils';

const WeeklyMobileCalendar = lazy(() =>
  import(
    '@wix/calendar-client-library-v3/dist/src/components/containers/WeeklyMobileCalendar/WeeklyMobileCalendar'
  ),
);

// const WeeklyMobileCalendar = lazy(() =>
//   import(
//     '../../localCalendars/components/containers/WeeklyMobileCalendar/WeeklyMobileCalendar'
//   ),
// );

const WeeklyWrapperMobile = ({ calendarsProps }) => {
  const { isPreLoaded, calendarRef, locale, isLiveSite } = calendarsProps;

  const isEditor = isEditorViewMode();
  const isResponsive =
    typeof calendarsProps.wixStyles.numbers.calendarHeightWeekly === 'undefined'
      ? false
      : calendarsProps.wixStyles.numbers.calendarHeightWeekly === 0;

  useEffect(() => {
    if (isResponsive) {
      setTimeout(() => {
        if (calendarRef?.current) {
          setHeight(calendarRef?.current?.clientHeight);
        }
      }, 100);
    }
  }, [isResponsive]);

  useEffect(() => {
    const minHeightResize = () => {
      if (isEditor) {
        const height = window.innerHeight;
        const width = window.innerWidth;

        const minHeight: number = 600;
        const minWidth: number = 320;

        if (width < minWidth) {
          resizeComponent({ width: minWidth, height });
        }
        if (height < minHeight) {
          resizeComponent({ width, height: minHeight });
        }

        // if (isResponsive) {
        //   if (
        //     calendarRef.current.scrollHeight !== height ||
        //     calendarRef.current.scrollHeight < height
        //   ) {
        //     setHeightByref();
        //   }
        // }
        if (isResponsive) {
          if (
            height > calendarRef.current.scrollHeight ||
            calendarRef.current.scrollHeight - height > 50
            // || calendarRef.current.scrollHeight !== height
          ) {
            resizeComponent({
              width,
              height: calendarRef.current.scrollHeight,
            }); // resizeComponent better than setHeight
            // setHeight(calendarRef?.current?.scrollHeight);
            // setHeightByref()
          }
        }
      }
    };

    window.addEventListener('resize', minHeightResize, false);
    return () => window.removeEventListener('resize', minHeightResize);
  }, []);

  const timeFormatWeekly =
    getStyleParams()?.numbers?.timeFormatWeekly === 24
      ? TimeFormatsEnum.twentyFourHours
      : TimeFormatsEnum.tweleveHours;

  return (
    <Suspense
      fallback={() => (
        <Loader
          isPreLoaded={isPreLoaded}
          locale={locale}
          isLiveSite={isLiveSite}
        />
      )}
    >
      <WeeklyMobileCalendar
        calendarsProps={{
          ...calendarsProps,
          isResponsive,
          timeFormat: timeFormatWeekly,
        }}
      />
    </Suspense>
  );
};

export default WeeklyWrapperMobile;
